export default "__VITE_ASSET__DLhjF9Hs__"